<app-data-grid-comp
    [tableId]="db_tables.LetterTemplates"
    [columns]="columns"
    [filterCategories]="filterCategories"
    [gridDataResult]="gridDataResult"
    [isLoading]="isLoading"
    [pageSize]="pageSize"
    [skip]="skip"
    category="Letters-Templates"
    [rowSelectionSettings]="{
        canSelectRows: true,
        selectableMode: 'multiple',
        selectRowBy: 'id'
    }"
    clickableRows="true"
    [isLoading]="isLoading"
    [clearSelectedItems]="clearSelectedItems"
    searchable="true"
    [sortable]="{
        mode: 'multiple'
    }"
    [sortableColumns]="sortableColumns"
    [accessAndHistoryURL]="accessAndHistoryURL"
    [historyDialogSettings]="{
        showEffectiveDateColumn: false
    }"
    [showAccessIcon]="false"
    [filterToggleDetails]="filterToggleDetails"
    [rowActionButtons]="gridActionButtons"
    (rowActionEvent)="copy($event)"
    (emitToggleFilter)="updateFilterToggleDetails($event)"
    (emitPageChangeEvent)="pageChange($event)"
    (emitSearchEvent)="search($event)"
    (emitOpenDialogEvent)="openEditor($event)"
    (emitDeleteEvent)="deleteItems($event)"
    (emitFilterEvent)="filterCallback($event)"
    (emitSortEvent)="sortChange($event)"
></app-data-grid-comp>